import React from "react";
import { Navigate } from "react-router-dom";
import useAppState from "../contexts/state";
import { AuthState } from "../contexts/slices/auth";

const AuthProtected = (props) => {
  const { isAuthenticated } = useAppState((state) => ({
    isAuthenticated: (state as AuthState).isAuthenticated,
  }));

  if (!isAuthenticated) {
    let hasRedirect = window?.location.pathname && !['/login', '/', '/dashboard'].includes(window.location.pathname);

    return <Navigate to={{
      pathname: "/login",
      ...(hasRedirect && { search: '?redirect=' + window.location.pathname })
    }} />;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

const AuthUnprotected = (props) => {
  const { isAuthenticated } = useAppState((state) => ({
    isAuthenticated: (state as AuthState).isAuthenticated,
  }));

  if (isAuthenticated && !props.disableRedirect) {
    return <Navigate to={{ pathname: "/dashboard" }} />;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export { AuthUnprotected, AuthProtected };